<template>
  <div>
    <a
      :href="href"
      target="_blank"
      class="
        w-[280px]
        h-[250px]
        md:w-[400px]
        md:h-[324px]
        flex flex-col
        bg-white
        shadow-md
        transition-all
        duration-200
        hover:shadow-lg
        rounded-md
      "
    >
      <div v-if="isVideo" class="w-[280px] md:w-[400px]">
        <iframe
          :width="videoWidth"
          :height="videoHeight"
          loading="lazy"
          :src="'https://www.youtube.com/embed/' + videoId"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
      <div v-else class="relative h-[156px] md:h-full flex items-center">
        <slot />
      </div>

      <div class="mb-8 ml-6 " :class="{'mt-4': isVideo, 'mt-6': !isVideo}">
        <p class="font-semibold truncate text-brand-blue text-body">
          {{ title }}
        </p>
        <p class="font-medium text-brand-gray-900 text-body">{{ author }}</p>
      </div>
    </a>
  </div>
</template>

<script>

import { useWindowSize } from '@vueuse/core';
import { computed } from 'vue';

export default {
  props: {
    title: String,

    author: String,

    isVideo: {
      type: Boolean,
      default: false,
    },

    href: String,

    videoId: String,
  },


  setup() {
    const { width } = useWindowSize();

    const videoWidth = computed(() => {
        if(width.value < 450) {
          return 280;
        }

        return 400;
    });

    const videoHeight = computed(() => {
        if(width.value < 450) {
          return 156;
        }

        return 225;
    });

    return {
      videoWidth,
      videoHeight
    }


  }
};
</script>

<style scoped>
.glass {
  background: rgba(255, 255, 255, 0.13);
  /* Glass */

  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(23px);
}
</style>